import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
// Extend Zod with OpenAPI
extendZodWithOpenApi(z);
// UUID validation
const uuidSchema = z.string().uuid('Invalid UUID format');
// Create module input schema
export const CreateModuleSchema = z.object({
    title: z
        .string()
        .min(1, 'Title is required')
        .max(255, 'Title must be less than 255 characters')
        .trim()
        .openapi({
        description: 'Module title',
        example: 'Getting Started',
    }),
    description: z
        .string()
        .max(5000, 'Description must be less than 5000 characters')
        .nullable()
        .optional()
        .openapi({
        description: 'Detailed module description',
        example: 'This module covers the fundamentals needed to get started',
    }),
});
// Update module input schema (all fields optional)
export const UpdateModuleSchema = z.object({
    title: z
        .string()
        .min(1, 'Title cannot be empty')
        .max(255, 'Title must be less than 255 characters')
        .trim()
        .optional()
        .openapi({
        description: 'Updated module title',
        example: 'Advanced Concepts',
    }),
    description: z
        .string()
        .max(5000, 'Description must be less than 5000 characters')
        .nullable()
        .optional()
        .openapi({
        description: 'Updated module description',
    }),
    topicIds: z
        .array(uuidSchema)
        .optional()
        .openapi({
        description: 'List of topic IDs associated with the module',
        example: ['550e8400-e29b-41d4-a716-446655440000'],
    }),
});
// List modules query parameters
export const ListModulesQuerySchema = z.object({
    page: z
        .string()
        .optional()
        .default('1')
        .transform((val) => parseInt(val, 10))
        .refine((val) => val > 0, 'Page must be greater than 0'),
    pageSize: z
        .string()
        .optional()
        .default('10')
        .transform((val) => parseInt(val, 10))
        .refine((val) => val > 0 && val <= 100, 'Page size must be between 1 and 100'),
    sortBy: z.enum(['createdAt', 'updatedAt', 'title']).optional().default('createdAt').openapi({
        description: 'Field to sort results by',
        example: 'createdAt',
    }),
    sortOrder: z.enum(['asc', 'desc']).optional().default('desc').openapi({
        description: 'Sort direction',
        example: 'desc',
    }),
    courseId: uuidSchema.optional().openapi({
        description: 'Filter modules by course ID',
        example: '550e8400-e29b-41d4-a716-446655440000',
    }),
});
// Module ID parameter validation
export const ModuleIdParamSchema = z.object({
    moduleId: uuidSchema.openapi({
        description: 'Unique identifier of the module',
        example: '550e8400-e29b-41d4-a716-446655440000',
    }),
});
// Get module query parameters (for include)
export const GetModuleQuerySchema = z.object({
    include: z.enum(['topics', 'content']).optional().openapi({
        description: 'Include related data: topics (1 level) or content (full nested structure with topics → lessons → steps)',
        example: 'topics',
    }),
});
// Module Schema
export const ModuleSchema = z
    .object({
    id: uuidSchema.openapi({
        description: 'Unique module identifier',
        example: '550e8400-e29b-41d4-a716-446655440000',
    }),
    title: z.string().openapi({ description: 'Module title', example: 'Getting Started' }),
    description: z.string().nullable().openapi({ description: 'Module description' }),
    createdAt: z.string().openapi({ description: 'Timestamp when the module was created' }),
    updatedAt: z.string().openapi({ description: 'Timestamp when the module was last updated' }),
})
    .openapi('Module');
//# sourceMappingURL=module.schema.js.map